"use client"

import style from "./HeroProgramSectionSliders.module.scss";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import LazyImageSection from "./LazyImageSection";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";

type ProgramCardsProps = {
  programName: string;
  subText: string;
  imgSrc: string;
  slug?: string;
  isLazy?: boolean;
  isLcp?: boolean;
};

const fireGTEvents = ({ program_name }) => {
  pushToDataLayer({
    event: "program_card_clicked",
    section_name: "hero_banner",
    program_name: program_name,
    page_url: window?.location?.href,
  });
};

const ProgramCards = ({
  programName = "",
  subText = "",
  imgSrc = "",
  slug = "",
  isLazy = false,
  isLcp = false,
}: ProgramCardsProps) => {
  const logoImport = () => {
    switch (slug) {
      case "/mba-hospital-healthcare-management":
        return (
          <div className={style.imgLogoAbsolute}>
            <UnivoImage
              src={IMAGE_ASSETS.medvarsityLogo}
              width={72}
              height={15}
              sizes="72px"
              alt="Medvarsity"
              loading="lazy"
              fetchPriority="low"
              unoptimized
            />
          </div>
        );

      case "/bca-fintech-ai-paytm":
        return (
          <div className={style.imgLogoAbsolute}>
            <UnivoImage
              src="/_a/icons/paytm-logo.svg"
              height={15}
              width={48}
              sizes="48px"
              alt="Paytm"
              loading="lazy"
              fetchPriority="low"
              unoptimized
            />
          </div>
        );

      case "/mba-construction-project-management":
        return (
          <div className={style.imgLogoAbsoluteRics}>
            <UnivoImage
              src={IMAGE_ASSETS.ricsHeroBadge}
              alt="project management Logo"
              width={72}
              height={29}
              sizes="72px"
              loading="lazy"
              fetchPriority="low"
            />
          </div>
        );

        case "mba-in-project-management":
        return (
          <div className={style.imgLogoAbsolutePMI}>
            <UnivoImage
              src={IMAGE_ASSETS.pmiLogo}
              alt="project management Logo"
              width={72}
              height={29}
              sizes="72px"
              loading="lazy"
              fetchPriority="low"
            />
          </div>
        );

      case "/mba-working-women":
        return (
          <div className={style.imgLogoAbsoluteWomen} aria-label="For Women">
            FOR WOMEN
          </div>
        );

      default:
        return null;
    }
  };
  return (
    <div onClick={() => fireGTEvents({ program_name: programName })} className={style.program_card}>
      <div className={style.img_section}>
        {isLazy ? (
          <LazyImageSection>
            <UnivoImage
              src={imgSrc}
              style={{
                borderTopRightRadius: "0.7rem",
                borderTopLeftRadius: "0.7rem",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "top center",
              }}
              fetchPriority="low"
              loading="lazy"
              width={140}
              height={120}
              sizes="(max-width: 1023px) 45vw, 140px"
              alt={"program image"}
            />
            {logoImport()}
          </LazyImageSection>
        ) : (
          <>
            <UnivoImage
              src={imgSrc}
              style={{
                borderTopRightRadius: "0.7rem",
                borderTopLeftRadius: "0.7rem",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "top center",
              }}
              quality={50}
              sizes="(max-width: 1023px) 45vw, 140px"
              width={140}
              height={120}
              alt={"program image"}
              loading="eager"
              fetchPriority="auto"
            />
            {logoImport()}
          </>
        )}
      </div>
      <div className={style.degree_info_section}>
        <p className={style.prgm_name}>{programName}</p>
        {subText && <p className={cn(style.specialization_text, "lining-nums")}>{subText}</p>}
      </div>
    </div>
  );
};

export default ProgramCards;
